import { DateFormats } from '@/constants/date';
import { ProposalRequest } from '@/pages/Lead/Create/components/ProposalRequests/types';
import { Axios, AxiosService } from '@/services/Axios';
import {
  AssignSalesRepresentativeVm,
  SelfDisqualifyLeadVm,
  SelfQualifyLeadVm,
  WatcherVm,
} from '@/types';
import { formatDate } from '@/utils/format-date';
import { clearPhoneNumberFormatting } from '@/utils/format-phone-number';

import { NewLeadFormData } from './types';

export class LeadControllerClass {
  constructor(private APIService: AxiosService) {}

  createNewLead = (formData: NewLeadFormData) => {
    const {
      salesRepresentativeEmail,
      salesRepresentativeLastName,
      salesRepresentativeFirstName,
      salesRepresentativePhoneNumber,
      isInsideSalesRequested,
      ...otherFormData
    } = formData;
    const payload: Record<
      string,
      | Date
      | Omit<ProposalRequest, 'id' | 'opened'>[]
      | WatcherVm[]
      | boolean
      | number
      | string
      | null
    > = { ...otherFormData };

    payload.phoneNumber = clearPhoneNumberFormatting(formData.phoneNumber);
    if (formData.appointmentDate) {
      payload.appointmentDate = formatDate(formData.appointmentDate, DateFormats.DataBase);
    }

    payload.isInsideSalesRequested = isInsideSalesRequested ? isInsideSalesRequested.value : null;

    return this.APIService.post<{ id: string }>('/leads', payload);
  };

  fetchLead = (id: string) => {
    return this.APIService.get(`/leads/${id}`);
  };

  updatePhotoAlbumLink = (id: string, photoAlbumLink: string) => {
    return this.APIService.put('/leads/add-photo-album-link', {
      leadId: id,
      photoAlbumLink,
    });
  };

  qualify = (payload: SelfQualifyLeadVm) => {
    return this.APIService.post('/leads/self-qualify-lead', {
      ...payload,
      phoneNumber: clearPhoneNumberFormatting(payload.phoneNumber),
    });
  };

  disqualify = (payload: SelfDisqualifyLeadVm) => {
    return this.APIService.post('/leads/self-disqualify-lead', payload);
  };

  assignSalesRepresentative = (payload: AssignSalesRepresentativeVm) => {
    return this.APIService.post('leads/assign-sales-representative', payload);
  };
}

export const LeadController = new LeadControllerClass(Axios);
